import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KeyCodes } from '@coolblue-development/constants';
import { Button, Flex, freddyTheme, IconButton, Input } from '@coolblue-development/freddy';
import { Magnifier } from '@coolblue-development/icons';
import { useEffect, useState } from 'react';
import { useTranslation } from '../i18n/useTranslation.js';
import { StyledSearchField } from './Typeahead.styled.js';
import { useDebounce } from './utils/index.js';
function SearchField({ setResults, isOpen, setIsOpen, fetcher, setQuery, searchUrl, }) {
    const [searchTerm, setSearchTerm] = useState(() => '');
    const debouncedSearchTerm = useDebounce({ value: searchTerm, delay: 700 });
    const { t } = useTranslation('searchField');
    useEffect(() => {
        async function search() {
            if (!setResults)
                return;
            try {
                const results = await fetcher(debouncedSearchTerm);
                setQuery(debouncedSearchTerm);
                if (results) {
                    setResults(results);
                }
            }
            catch (e) {
                // We log the error to datadog in the server action
            }
        }
        search();
    }, [debouncedSearchTerm, setResults, fetcher, setQuery]);
    function handleChange(event) {
        setSearchTerm(event.target.value);
    }
    function handleKeyDown(event) {
        if (event.key === KeyCodes.ESCAPE && !searchTerm) {
            setIsOpen(false);
        }
    }
    return (_jsxs(Flex, { component: "form", method: "get", action: searchUrl, children: [_jsx(StyledSearchField, { children: _jsx(Input, { placeholder: t('placeholder'), "aria-label": t('ariaLabel'), role: "searchbox", autoComplete: "off", autoCorrect: "off", type: "search", id: "search", name: "query", value: searchTerm, onChange: handleChange, onFocus: () => setIsOpen(true), onKeyDown: handleKeyDown, variant: "borderless", endAdornment: _jsx(IconButton, { size: "large", "aria-label": t('buttonAriaLabel'), type: "submit", sx: {
                            [freddyTheme.breakpoint.maxWidth('md')]: {
                                backgroundColor: freddyTheme.color.background.primary,
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                                padding: `calc(${freddyTheme.spacing[300]} - 2px) !important`,
                                svg: {
                                    fill: freddyTheme.color.icon.inverse,
                                },
                                '&:hover': {
                                    backgroundColor: freddyTheme.color.background.primary,
                                },
                            },
                            [freddyTheme.breakpoint.minWidth('md')]: {
                                '&:hover': {
                                    backgroundColor: freddyTheme.color.background.base,
                                },
                            },
                        }, children: _jsx(Magnifier, {}) }) }) }), isOpen && (_jsx(Button, { variant: "tertiary", hideFrom: "md", onClick: () => setIsOpen(false), children: t('cancelButtonText') }))] }));
}
export { SearchField };
//# sourceMappingURL=SearchField.js.map